import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import FireExtinguisherIcon from "@mui/icons-material/FireExtinguisher";
import SosIcon from "@mui/icons-material/Sos";
import DoorFrontIcon from "@mui/icons-material/DoorFront";
import { ReactComponent as H24Logo } from "../../../../icons/h24.svg";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import WarningIcon from "@mui/icons-material/Warning";

const healthCategoryIcon = <LocalHospitalIcon />;
const fireAlarmCategoryIcon = <LocalFireDepartmentIcon />;
const panicCategoryIcon = <SosIcon />;
const bulglarCategoryIcon = <MeetingRoomIcon />;
const h24CategoryIcon = <H24Logo />;
const fireCategoryIcon = <FireExtinguisherIcon />;
const openCategoryIcon = <MeetingRoomIcon />;
const closeCategoryIcon = <DoorFrontIcon />;
const highlightedCategoryIcon = <NotificationsActiveIcon />;
const systemErrorCategoryIcon = <WarningIcon />;

const cids = [
  {
    icon: healthCategoryIcon,
    alarm: {
      code: "1100",
      descr: {
        "hu-hu": "Orvoshívás",
        "en-gb": "Doctor calling",
        "sk-sk": "Volanie zdravotníckej pomoci",
      },
    },
    recovery: {
      code: "3100",
      descr: {
        "hu-hu": "Orvoshívás visszaállás",
        "en-gb": "Restore of emergency call",
        "sk-sk": "Obnova: volanie lekára",
      },
    },
  },
  {
    icon: healthCategoryIcon,
    alarm: {
      code: "1101",
      descr: {
        "hu-hu": "Személyi vészhelyzet",
        "en-gb": "Personal emergency",
        "sk-sk": "Ohrozenie osoby",
      },
    },
    recovery: {
      code: "3101",
      descr: {
        "hu-hu": "Személyi vészhelyzet visszaállás",
        "en-gb": "Restore of personal emergency",
        "sk-sk": "Obnova: osoba v ohrození",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1110",
      descr: {
        "hu-hu": "Tűzjelzés",
        "en-gb": "Fire alarm",
        "sk-sk": "Požiarna signalizácia",
      },
    },
    recovery: {
      code: "3110",
      descr: {
        "hu-hu": "Tűzjelzés visszaállás",
        "en-gb": "Fire alarm set back",
        "sk-sk": "Obnova: požiarna signalizácia",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1111",
      descr: {
        "hu-hu": "Füstriasztás",
        "en-gb": "Smoke alarm",
        "sk-sk": "Dymový poplach",
      },
    },
    recovery: {
      code: "3111",
      descr: {
        "hu-hu": "Füstriasztás visszaállás",
        "en-gb": "Restore of smoke alarm",
        "sk-sk": "Obnova: dymový poplach",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1112",
      descr: {
        "hu-hu": "Tűzriasztás",
        "en-gb": "Fire alarm",
        "sk-sk": "Požiarny poplach",
      },
    },
    recovery: {
      code: "3112",
      descr: {
        "hu-hu": "Tűzriasztás visszaállás",
        "en-gb": "Restore of fire alarm",
        "sk-sk": "Obnova: požiarny poplach",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1113",
      descr: {
        "hu-hu": "Vízfolyás riasztás",
        "en-gb": "Flood alarm",
        "sk-sk": "Poplach zaplavenia",
      },
    },
    recovery: {
      code: "3113",
      descr: {
        "hu-hu": "Vízfolyás riasztás visszaállás",
        "en-gb": "Restore of flood alarm",
        "sk-sk": "Obnova: zaplavenie",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1114",
      descr: {
        "hu-hu": "Hőriasztás",
        "en-gb": "Heat alarm",
        "sk-sk": "Teplotný poplach",
      },
    },
    recovery: {
      code: "3114",
      descr: {
        "hu-hu": "Hőriasztás visszaállás",
        "en-gb": "Restore of heat alarm",
        "sk-sk": "Obnova: teplotný poplach",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1115",
      descr: {
        "hu-hu": "Kézi tűzjelzés",
        "en-gb": "Manual fire alarm",
        "sk-sk": "Ručná požiarna signalizácia",
      },
    },
    recovery: {
      code: "3115",
      descr: {
        "hu-hu": "Kézi tűzjelzés visszaállás",
        "en-gb": "Restore of manual fire alarm",
        "sk-sk": "Obnova: ručná signalizácia požiaru",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1116",
      descr: {
        "hu-hu": "Hőérzékelős kábel riasztás",
        "en-gb": "Heat sensor cable alarm",
        "sk-sk": "Poplach z kábla s tepelným snímačom",
      },
    },
    recovery: {
      code: "3116",
      descr: {
        "hu-hu": "Hoérzékelős kábel riasztás visszaállás",
        "en-gb": "Restore of heat sensing cable alarm",
        "sk-sk": "Obnova: poplach z kábla s tepelným snímačom",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1117",
      descr: {
        "hu-hu": "Láng riasztás",
        "en-gb": "Flame alarm",
        "sk-sk": "Plameň",
      },
    },
    recovery: {
      code: "3117",
      descr: {
        "hu-hu": "Láng riasztás visszaállás",
        "en-gb": "Restore of flame alarm",
        "sk-sk": "Obnova: plameň",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1118",
      descr: {
        "hu-hu": "Kézi riasztás (near alarm)",
        "en-gb": "Hand alarm",
        "sk-sk": "Ručne vyvolaný poplach",
      },
    },
    recovery: {
      code: "3118",
      descr: {
        "hu-hu": "Kézi riasztás (near alarm) visszaállás",
        "en-gb": "Restore of manual alarm (near alarm)",
        "sk-sk": "Obnova: ručná signalizácia",
      },
    },
  },
  {
    icon: fireAlarmCategoryIcon,
    alarm: {
      code: "1119",
      descr: {
        "hu-hu": "Edény üritve: %F címen",
      },
    },
    recovery: null,
  },
  {
    icon: panicCategoryIcon,
    alarm: {
      code: "1120",
      descr: {
        "hu-hu": "Pánikjelzés",
        "en-gb": "Panic alarm",
        "sk-sk": "PÁNIK polach",
      },
    },
    recovery: {
      code: "3120",
      descr: {
        "hu-hu": "Pánikjelzés visszaállás",
        "en-gb": "Restore of panic alarm",
        "sk-sk": "Obnova: signalizácia PANIK",
      },
    },
  },
  {
    icon: panicCategoryIcon,
    alarm: {
      code: "1122",
      descr: {
        "hu-hu": "Csendes pánik",
        "en-gb": "Silent panic",
        "sk-sk": "Tichý poplach",
      },
    },
    recovery: {
      code: "3122",
      descr: {
        "hu-hu": "Csendes pánik visszaállás",
        "en-gb": "Restore of quiet panic",
        "sk-sk": "Obnova: tichý poplach",
      },
    },
  },
  {
    icon: panicCategoryIcon,
    alarm: {
      code: "1123",
      descr: {
        "hu-hu": "Hangos pánikjelzés",
        "en-gb": "Loud panic alarm",
        "sk-sk": "Hlasitý poplach",
      },
    },
    recovery: {
      code: "3123",
      descr: {
        "hu-hu": "Hangos pánikjelzés visszaállás",
        "en-gb": "Restore of loud panic alarm",
        "sk-sk": "Obnova: hlasitý poplach",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1130",
      descr: {
        "hu-hu": "Betörés",
        "en-gb": "Intrusion",
        "sk-sk": "Narušenie",
      },
    },
    recovery: {
      code: "3130",
      descr: {
        "hu-hu": "Betörés visszaállás",
        "en-gb": "Restore of incursion",
        "sk-sk": "Obnova: vlámanie",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1131",
      descr: {
        "hu-hu": "Kültéri riasztás",
        "en-gb": "Outdoor alarm",
        "sk-sk": "Exteriérový poplach",
      },
    },
    recovery: {
      code: "3131",
      descr: {
        "hu-hu": "Kültéri riasztás visszaállás",
        "en-gb": "Restore of outdoor alarm",
        "sk-sk": "Obnova: exteriérový poplach",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1132",
      descr: {
        "hu-hu": "Beltéri riasztás",
        "en-gb": "Indoor alarm",
        "sk-sk": "Interiérový poplach",
      },
    },
    recovery: {
      code: "3132",
      descr: {
        "hu-hu": "Beltéri riasztás visszaállás",
        "en-gb": "Restore of indoor alarm",
        "sk-sk": "Obnova: interiérový poplach",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1133",
      descr: {
        "hu-hu": "24 órás zónariaszás",
        "en-gb": "24 hour zone alarm",
        "sk-sk": "24 hodinový poplach",
      },
    },
    recovery: {
      code: "3133",
      descr: {
        "hu-hu": "24 órás zónariaszás visszaállás",
        "en-gb": "Restore of 24-hour zone alarm",
        "sk-sk": "Obnova: 24 hodinový zónový poplach",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1134",
      descr: {
        "hu-hu": "Be/kijárati zónariasztás",
        "en-gb": "Entry/Exit zone alarm",
        "sk-sk": "Vstupný/výstupný poplach",
      },
    },
    recovery: {
      code: "3134",
      descr: {
        "hu-hu": "Be/kijárati zónariasztás visszaállás",
        "en-gb": "Restore of entry/exit zone alarm",
        "sk-sk": "Obnova: vstupný/výstupný zónový poplach",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1135",
      descr: {
        "hu-hu": "Éjszakai/nappali zónariasztás",
        "en-gb": "Nightly/Daily zone alarm",
        "sk-sk": "Denný/nočný poplach",
      },
    },
    recovery: {
      code: "3135",
      descr: {
        "hu-hu": "Éjszakai/nappali zónariasztás visszaállás",
        "en-gb": "Restore of night/day zone alarm",
        "sk-sk": "Obnova: denný/nočný zónový poplach",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1136",
      descr: {
        "hu-hu": "Külső ajtó riasztás",
        "en-gb": "Outer door alarm",
        "sk-sk": "Poplach exteriérových dverí",
      },
    },
    recovery: {
      code: "3136",
      descr: {
        "hu-hu": "Külso ajtó riasztás visszaállás",
        "en-gb": "Restore of outer door alarm",
        "sk-sk": "Obnova: poplach exteriérových dverí",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1137",
      descr: {
        "hu-hu": "Szabotázs riasztás",
        "en-gb": "Sabotage alarm",
        "sk-sk": "Sabotážny poplach",
      },
    },
    recovery: {
      code: "3137",
      descr: {
        "hu-hu": "Szabotázs riasztás visszaállás",
        "en-gb": "Restore of sabotage alarm",
        "sk-sk": "Obnova: sabotážny poplach",
      },
    },
  },
  {
    icon: bulglarCategoryIcon,
    alarm: {
      code: "1138",
      descr: {
        "hu-hu": "Kézi riasztás (near alarm)",
        "en-gb": "Manual alarm",
        "sk-sk": "Ručná signalizácia",
      },
    },
    recovery: {
      code: "3138",
      descr: {
        "hu-hu": "Kézi riasztás (near alarm) visszaállás",
        "en-gb": "Restore of manual alarm (near alarm)",
        "sk-sk": "Obnova: ručná signalizácia",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1150",
      descr: {
        "hu-hu": "24 órás riasztás (nem betörés)",
        "en-gb": "24 hour alarm (not intrusion)",
        "sk-sk": "24 hodinový poplach (nie vlámanie)",
      },
    },
    recovery: {
      code: "3150",
      descr: {
        "hu-hu": "24 órás riasztás (nem betörés) visszaállás",
        "en-gb": "Restore of 24 hour alarm (not incursion)",
        "sk-sk": "Obnova: 24 hodinový poplach (nie vlámanie)",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1151",
      descr: {
        "hu-hu": "Gázérzékelés",
        "en-gb": "Gas sensing",
        "sk-sk": "Detekcia plynu",
      },
    },
    recovery: {
      code: "3151",
      descr: {
        "hu-hu": "Gázérzékelés visszaállás",
        "en-gb": "Restore of gas sensing",
        "sk-sk": "Obnova: detekcia úniku plynu",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1152",
      descr: {
        "hu-hu": "Fagyás",
        "en-gb": "Freezing",
        "sk-sk": "Mrzne",
      },
    },
    recovery: {
      code: "3152",
      descr: {
        "hu-hu": "Fagyás visszaállás",
        "en-gb": "Restore of freezing",
        "sk-sk": "Obnova: mrzne",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1153",
      descr: {
        "hu-hu": "Hőmérsékletvesztés",
        "en-gb": "Temperature lost",
        "sk-sk": "Strata teploty",
      },
    },
    recovery: {
      code: "3153",
      descr: {
        "hu-hu": "Hőmérsékletvesztés visszaállás",
        "en-gb": "Restore of temperature lost",
        "sk-sk": "Obnova: strata teploty",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1154",
      descr: {
        "hu-hu": "Vízszivárgás",
        "en-gb": "Water leak",
        "sk-sk": "Únik vody",
      },
    },
    recovery: {
      code: "3154",
      descr: {
        "hu-hu": "Vízszivárgás visszaállás",
        "en-gb": "Restore of water leak",
        "sk-sk": "Obnova: únik vody",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1155",
      descr: {
        "hu-hu": "Csőtörés",
        "en-gb": "Broken pipe",
        "sk-sk": "Prasknutie potrubia",
      },
    },
    recovery: {
      code: "3155",
      descr: {
        "hu-hu": "Csőtörés visszaállás",
        "en-gb": "Restore of broken conduit",
        "sk-sk": "Obnova: prasknutie potrubia",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1156",
      descr: {
        "hu-hu": "Day trouble",
        "en-gb": "Day trouble",
        "sk-sk": "Denná porucha",
      },
    },
    recovery: {
      code: "3156",
      descr: {
        "hu-hu": "Day trouble visszaállás",
        "en-gb": "Restore of day trouble",
        "sk-sk": "Obnova: denná trouble",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1157",
      descr: {
        "hu-hu": "Alacsony gázszint",
        "en-gb": "Low gas level",
        "sk-sk": "Nízka hľadina plynu",
      },
    },
    recovery: {
      code: "3157",
      descr: {
        "hu-hu": "Alacsony gázszint visszaállás",
        "en-gb": "Restore of low gas level",
        "sk-sk": "Obnova: nízka hľadina plynu",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1158",
      descr: {
        "hu-hu": "Magas hőmérséklet",
        "en-gb": "High temperature",
        "sk-sk": "Vysoká teplota",
      },
    },
    recovery: {
      code: "3158",
      descr: {
        "hu-hu": "Magas hőmérséklet visszaállás",
        "en-gb": "Restore of high temperature",
        "sk-sk": "Obnova: vysoká teplota",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1159",
      descr: {
        "hu-hu": "Alacsony homérséklet",
        "en-gb": "Low temperature",
        "sk-sk": "Nízka teplota",
      },
    },
    recovery: {
      code: "3159",
      descr: {
        "hu-hu": "Alacsony hőmérséklet visszaállás",
        "en-gb": "Restore of low temperature",
        "sk-sk": "Obnova: nízka teplota",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1161",
      descr: {
        "hu-hu": "Légkeringetés megszakadt",
        "en-gb": "Air circulation is broken",
        "sk-sk": "Prerušená cirkulácia vzduchu",
      },
    },
    recovery: {
      code: "3161",
      descr: {
        "hu-hu": "Légkeringetés megszakadt visszaállás",
        "en-gb": "Restore of broken air circulation",
        "sk-sk": "Obnova: prerušená cirkulácia vzduchu",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1162",
      descr: {
        "hu-hu": "Szénmonoxid veszély",
        "en-gb": "CO danger",
        "sk-sk": "Nebezpečenstvo CO",
      },
    },
    recovery: {
      code: "3162",
      descr: {
        "hu-hu": "Szénmonoxid veszély visszaállás",
        "en-gb": "Restore of CO danger",
        "sk-sk": "Obnova: nebezpečenstvo CO",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1163",
      descr: {
        "hu-hu": "Tartályszint",
        "en-gb": "Tank level",
        "sk-sk": "Hľadina nádrže",
      },
    },
    recovery: {
      code: "3163",
      descr: {
        "hu-hu": "Tartályszint visszaállás",
        "en-gb": "Restore of tank level",
        "sk-sk": "Obnova: hľadina nádrže",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1164",
      descr: {
        "hu-hu": "Ütésérzékelés",
      },
    },
    recovery: {
      code: "3164",
      descr: {
        "hu-hu": "Ütésérzékelés Visszaállás",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1165",
      descr: {
        "hu-hu": "Magas vízhőmérséklet",
      },
    },
    recovery: {
      code: "3165",
      descr: {
        "hu-hu": "Magas vízhőmérséklet visszaállás",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1166",
      descr: {
        "hu-hu": "Fűtés minimum víznyomás alacsony",
      },
    },
    recovery: {
      code: "3166",
      descr: {
        "hu-hu": "Fűtés minimum víznyomás visszaállás",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1167",
      descr: {
        "hu-hu": "HMV minimum víznyomás alacsony",
      },
    },
    recovery: {
      code: "3167",
      descr: {
        "hu-hu": "HMV minimum víznyomás visszaállás",
      },
    },
  },
  {
    icon: h24CategoryIcon,
    alarm: {
      code: "1168",
      descr: {
        "hu-hu": "melegvíz alacsony hő",
      },
    },
    recovery: null,
  },
  {
    icon: fireCategoryIcon,
    alarm: {
      code: "1201",
      descr: {
        "hu-hu": "Alacsony víznyomás",
        "en-gb": "Low water pressure",
        "sk-sk": "Malý tlak vody",
      },
    },
    recovery: {
      code: "3201",
      descr: {
        "hu-hu": "Alacsony víznyomás visszaállás",
        "en-gb": "Restore of low water pressure",
        "sk-sk": "Obnova: malý tlak vody",
      },
    },
  },
  {
    icon: fireCategoryIcon,
    alarm: {
      code: "1202",
      descr: {
        "hu-hu": "Alacsony CO2 szint",
        "en-gb": "Low CO2 level",
        "sk-sk": "Nízka hľadina CO2",
      },
    },
    recovery: {
      code: "3202",
      descr: {
        "hu-hu": "Alacsony CO2 szint visszaállás",
        "en-gb": "Restore of low CO2 level",
        "sk-sk": "Obnova: nízka hľadina CO2",
      },
    },
  },
  {
    icon: fireCategoryIcon,
    alarm: {
      code: "1203",
      descr: {
        "hu-hu": "Kapuszelep érzékelő",
        "en-gb": "Gate valve sensor",
        "sk-sk": "Snímač ventilu brány",
      },
    },
    recovery: {
      code: "3203",
      descr: {
        "hu-hu": "Kapuszelep érzékelő visszaállás",
        "en-gb": "Restore of gate valve sensor",
        "sk-sk": "Obnova: snímač ventilu brány",
      },
    },
  },
  {
    icon: fireCategoryIcon,
    alarm: {
      code: "1204",
      descr: {
        "hu-hu": "Alacsony vízszint",
        "en-gb": "Low water level",
        "sk-sk": "Nízka hľadina vody",
      },
    },
    recovery: {
      code: "3204",
      descr: {
        "hu-hu": "Alacsony vízszint visszaállás",
        "en-gb": "Restore of low water level",
        "sk-sk": "Obnova: nízka hľadina vody",
      },
    },
  },
  {
    icon: fireCategoryIcon,
    alarm: {
      code: "1205",
      descr: {
        "hu-hu": "Szivattyú aktiválva",
        "en-gb": "Pump activated",
        "sk-sk": "Čerpadlo aktivované",
      },
    },
    recovery: {
      code: "3205",
      descr: {
        "hu-hu": "Szivattyú aktiválva visszaállás",
        "en-gb": "Restore of pump activated",
        "sk-sk": "Obnova: čerpadlo aktivované",
      },
    },
  },
  {
    icon: fireCategoryIcon,
    alarm: {
      code: "1206",
      descr: {
        "hu-hu": "Szivattyú hiba",
        "en-gb": "Pump error",
        "sk-sk": "Porucha čerpadla",
      },
    },
    recovery: {
      code: "3206",
      descr: {
        "hu-hu": "Szivattyú hiba visszaállás",
        "en-gb": "Restore of pump error",
        "sk-sk": "Obnova: porucha čerpadla",
      },
    },
  },
  {
    icon: systemErrorCategoryIcon,
    alarm: {
      code: "1302",
      descr: {
        "hu-hu": "Akkumulátor hiba",
        "en-gb": "Battery error",
      },
    },
    recovery: {
      code: "3302",
      descr: {
        "hu-hu": "Akkumulátor hiba visszaállás",
        "en-gb": "Restore of battery error",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1400",
      descr: {
        "hu-hu": "Partició nyitás",
        "en-gb": "Opening partition",
        "sk-sk": "Otvorenie partície",
      },
    },
    recovery: {
      code: "3400",
      descr: {
        "hu-hu": "Zárás",
        "en-gb": "Closing",
        "sk-sk": "Zatvorenie",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1401",
      descr: {
        "hu-hu": "Nyitás a %Y. kóddal",
        "en-gb": "Opening with %Y. code",
        "sk-sk": "Otvorenie kódom %Y.",
      },
    },
    recovery: {
      code: "3401",
      descr: {
        "hu-hu": "Zárás a %Y. kóddal",
        "en-gb": "Closing with %Y. code",
        "sk-sk": "Zatvorenie kódom %Y.",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1402",
      descr: {
        "hu-hu": "Nyitás a %Y. kóddal",
        "en-gb": "Opening with %Y. code",
        "sk-sk": "Otvorenie kódom %Y.",
      },
    },
    recovery: {
      code: "3402",
      descr: {
        "hu-hu": "Zárás a %Y. kóddal %X. partíció (%G)",
        "en-gb": "Closing with %Y. code",
        "sk-sk": "Zatvorenie kódom %Y.",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1403",
      descr: {
        "hu-hu": "Automatikus nyitás",
        "en-gb": "Automatic opening",
        "sk-sk": "Autamatické otvorenie",
      },
    },
    recovery: {
      code: "3403",
      descr: {
        "hu-hu": "Automatikus zárás",
        "en-gb": "Automatic closing",
        "sk-sk": "Automatické zatvorenie",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1404",
      descr: {
        "hu-hu": "Utólagos nyitás",
        "en-gb": "Post-opening",
        "sk-sk": "Dodatočné otvorenie",
      },
    },
    recovery: {
      code: "3404",
      descr: {
        "hu-hu": "Utólagos zárás",
        "en-gb": "Post-closing",
        "sk-sk": "Dodatočné zatvorenie",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1405",
      descr: {
        "hu-hu": "Késleltetett nyitás",
        "en-gb": "Delayed opening",
        "sk-sk": "Oneskorené otvorenie",
      },
    },
    recovery: {
      code: "3405",
      descr: {
        "hu-hu": "Késleltetett zárás",
        "en-gb": "Delayed closing",
        "sk-sk": "Oneskorené zatvorenie",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1406",
      descr: {
        "hu-hu": "Riasztás utáni nyitás",
        "en-gb": "Opening after alarm",
        "sk-sk": "Otvorenie po poplachu",
      },
    },
    recovery: {
      code: "3406",
      descr: {
        "hu-hu": "Riasztás utáni nyitás",
        "en-gb": "Opening after alarm",
        "sk-sk": "Otvorenie po poplachu",
      },
    },
  },
  {
    icon: openCategoryIcon,
    alarm: {
      code: "1407",
      descr: {
        "hu-hu": "Távvezérelt nyitás",
        "en-gb": "Remote controlled opening",
        "sk-sk": "Diaľkové otvorenie",
      },
    },
    recovery: {
      code: "3407",
      descr: {
        "hu-hu": "Távvezérelt zárás",
        "en-gb": "Remote controlled closing",
        "sk-sk": "Diaľkové zatvorenie",
      },
    },
  },
  {
    icon: closeCategoryIcon,
    alarm: {
      code: "1408",
      descr: {
        "hu-hu": "Gyors élesítés",
        "en-gb": "Fast alarming",
        "sk-sk": "Rýchle zaostrenie",
      },
    },
    recovery: {
      code: "3408",
      descr: {
        "hu-hu": "Gyors élesítés",
        "en-gb": "Fast alarming",
        "sk-sk": "Rýchle zaostrenie",
      },
    },
  },
  {
    icon: highlightedCategoryIcon,
    alarm: {
      code: "4101",
      descr: {
        "hu-hu": "Kimenet aktív",
        "en-gb": "Output active",
      },
    },
    recovery: {
      code: "4301",
      descr: {
        "hu-hu": "Kimenet inaktív",
        "en-gb": "Output inactive",
      },
    },
  },
];

export default cids;
